/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DtoMfaSetup } from '../../models/dto-mfa-setup';
import { MfaSetupResponse } from '../../models/mfa-setup-response';

export interface IdentityControllerMfaSetup$Params {
      body: DtoMfaSetup
}

export function identityControllerMfaSetup(http: HttpClient, rootUrl: string, params: IdentityControllerMfaSetup$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MfaSetupResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, identityControllerMfaSetup.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: MfaSetupResponse;
      }>;
    })
  );
}

identityControllerMfaSetup.PATH = '/identity/session/mfa/setup';
